import React, { useCallback, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Textinput, Button, Flex, Typo, LoadingDots } from '../../../ui';
import { TOAST_ERROR } from '../../../utils/constants';
import SupportLink from './SupportLink';
import { loadGoogleScript } from '../../../App';
import { media } from '../../../utils/media';
import { enqueueSnackbar } from 'notistack';
import { useLogin } from '../hooks/useAuthActions';
import { useIsLoginPending } from '../hooks';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  min-width: 420px;
  min-height: 400px;
  justify-content: center;
  align-self: center;
  ${media.lessThan('tablet')} {
    min-width: 260px;
  }
`;
const ButtonStyled = styled(Button)`
  align-self: flex-end;
`;

const SocialButtons = styled.div`
  display: flex;
  gap: 30px;
  ${media.lessThan('tablet')} {
    flex-direction: column;
  }
`;

const Login = ({ onForgotPass, onLogginCallBack }) => {
  const { t } = useTranslation();
  const emailRef = useRef(null);
  const passRef = useRef(null);
  const login = useLogin();
  const isLoginPending = useIsLoginPending();

  useEffect(() => {
    /* global google */
    loadGoogleScript()
      .then(() => {
        google.accounts.id.renderButton(document.getElementById('GoogleLoginBtn'), {
          theme: 'filled_black',
          text: 'signin',
          shape: 'circle',
        });
      })
      .catch(console.error);
  }, []);

  const handleLogIn = useCallback(
    (event) => {
      if (!!event.key && event.key !== 'Enter') return null;
      const emailValue = emailRef.current.value;
      const passValue = passRef.current.value;
      if (!emailValue || !passValue) return enqueueSnackbar(t('auth.missingCreds'), { variant: TOAST_ERROR });
      login({ identity: emailValue, credential: passValue }).then(() => {
        onLogginCallBack && onLogginCallBack();
      });
    },
    [login, onLogginCallBack, t],
  );

  return (
    <Wrapper>
      {isLoginPending ? (
        <LoadingDots message={t('auth.loggingIn')} fullContainer={false} />
      ) : (
        <>
          <Flex direction='column' width='100%' align='flex-start'>
            <Textinput autoFocus margin='dense' id='email' label={t('globals.email')} type='email' fullWidth inputRef={emailRef} onKeyPress={handleLogIn} />
            <Textinput margin='dense' id='pass' label={t('globals.password')} type='password' fullWidth inputRef={passRef} onKeyPress={handleLogIn} />
            <Button $asText onClick={onForgotPass}>
              {t('auth.forgotPassword')}
            </Button>
          </Flex>

          <Flex direction='column' gap='30'>
            <ButtonStyled onClick={handleLogIn}>{t('auth.signIn')}</ButtonStyled>
            <Flex direction='column' gap='8'>
              <Typo.Info>{t('auth.orSignInWith')}</Typo.Info>
              <SocialButtons>
                <div id={'GoogleLoginBtn'} />
                {/* <Button $variant='primary' icon='Facebook' onClick={() => console.log('facebook')}>{t('auth.facebook')}</Button> */}
              </SocialButtons>
            </Flex>
            <SupportLink />
          </Flex>
        </>
      )}
    </Wrapper>
  );
};

export default Login;
